import BestMedSupInCity from '@components/seo/medsup/BestMedSupInCity';
import { Routes } from '@constants/routes';
import { stateCodeToName } from '@constants/stateData/stateCodeToName';
import { getPublishDate } from '@utils/index';
import { decodeSlug } from '@utils/slugs';
import { NextSeo } from 'next-seo';
import { fsmApi } from '../../../../lib/requests';

const CityPage = ({ stateSlug, citySlug, cityData, cityList }) => {
  const title = `Best Medicare Supplement Plans in ${cityData.name}, ${cityData.stateCode} for 2025`;
  const description = `Best Medicare Supplement Plans in ${cityData.name}, ${cityData.stateCode} for 2025`;
  const alt = `Scene of ${cityData.state}`;

  const publishDate = getPublishDate(0);

  return (
    <>
      <NextSeo
        title={title}
        description={description}
        openGraph={{
          type: 'website',
          locale: 'en-US',
          title,
          description,
          url: `https://www.fairsquaremedicare.com${Routes.bestMedicareSupplement}/${stateSlug}/${citySlug}`,
          site_name: 'Fair Square Medicare',
          article: {
            publishedTime: publishDate.toISOString(),
            modifiedTime: publishDate.toISOString(),
            tags: ['medicare', 'supplement', cityData.name.toLowerCase(), '2025'],
          },
          images: [
            {
              url: cityData.image,
              width: 1200,
              height: 630,
              alt,
            },
          ],
        }}
      />
      <BestMedSupInCity
        data={{
          ...cityData,
          stateSlug,
          state: decodeSlug(stateSlug),
          citySlug,
          alt,
          publishDate,
          title,
          cityList,
        }}
      />
    </>
  );
};

export async function getServerSideProps({ params }) {
  try {
    const stateName = decodeSlug(params.stateSlug);
    const stateCode = Object.entries(stateCodeToName).find(([, name]) => name === stateName)[0];

    const [cityDataRes, citiesRes] = await Promise.all([
      fsmApi.get(`/blog/medigap/${params.stateSlug}/${params.citySlug}`),
      fsmApi.get(`/blog/cities/${stateCode}?limit=50`),
    ]);

    return {
      props: {
        ...params,
        cityData: cityDataRes.data,
        cityList: citiesRes.data,
      },
    };
  } catch (error) {
    console.error(`Error fetching ms city data for ${params.stateSlug}/${params.citySlug}. Redirecting.`, error);
    return {
      redirect: {
        destination: `${Routes.bestMedicareSupplement}/${params.stateSlug}`,
        permanent: false,
      },
    };
  }
}

export default CityPage;
